import { render, staticRenderFns } from "./sosList.vue?vue&type=template&id=4a89e5d8&scoped=true&"
import script from "./sosList.vue?vue&type=script&lang=js&"
export * from "./sosList.vue?vue&type=script&lang=js&"
import style0 from "./sosList.vue?vue&type=style&index=0&id=4a89e5d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a89e5d8",
  null
  
)

export default component.exports